import { apiSlice } from '../api/api-slice';
import { AuditActivityPaginatedResult, AuditActivityViewModel, PaginatedResult } from '../api/models';

export interface AuditActivityListRequest {
  pageNumber: number;
  pageSize: number;
  category: string;
  fromUtc: string;
  toUtc : string;
  // Optional filters. Which ones apply depends on the category; the API passes them all
  // through and each stored procedure uses only those it has a column for.
  customerName?: string;
  partnerName?: string;
  partnerId?: string;
  source?: string;
  target?: string;
  transactionTypes?: string;
  entityName?: string;
}

export const auditactivityApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      fetchAuditActivity: builder.query<AuditActivityPaginatedResult, AuditActivityListRequest>({
        query(request) {
          const params = new URLSearchParams();
          params.append('PageNumber', request.pageNumber.toString());
          params.append('PageSize', request.pageSize.toString());
          params.append('Category', request.category);
          params.append('FromUtc', request.fromUtc);
          params.append('ToUtc', request.toUtc);

          const filters: Record<string, string | undefined> = {
            CustomerName: request.customerName,
            PartnerName: request.partnerName,
            PartnerId: request.partnerId,
            Source: request.source,
            Target: request.target,
            TransactionTypes: request.transactionTypes,
            EntityName: request.entityName,
          };
          Object.keys(filters).forEach((key) => {
            const value = filters[key];
            if (value !== undefined && value !== null && `${value}`.trim() !== '') {
              params.append(key, value);
            }
          });

          return `/auditLog/audit-activity?${params.toString()}`;
        },
        forceRefetch({ currentArg, previousArg }) {
          return true;
        },
        providesTags: ['AuditActivity'],
      }),
    };
  },
});

export const {
  useFetchAuditActivityQuery,
} = auditactivityApi;
